import { render, staticRenderFns } from "./UserInjuryInfo.vue?vue&type=template&id=00c62e4c&"
import script from "./UserInjuryInfo.vue?vue&type=script&lang=js&"
export * from "./UserInjuryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports